export default __webpack_public_path__ + "static/media/logo.93628912.svg";